import { stripNbsp, trimNewLines } from '~/utils/text';
/**
 * Adds "-" in beginning and replaces last point in text with byline.
 */
export const getInterviewText = function (text, byline) {
  let interview = text;

  interview = stripNbsp(interview);
  interview = trimNewLines(interview);
  interview = interview.replace(/^<p>/, '<p>- ');

  if (interview && byline) {
    interview = interview.replace(/\.([^.]*)$/, `, säger ${byline}.$1`);
  }

  return interview;
};
